import { render, staticRenderFns } from "./providerPtGlobalUpdate.vue?vue&type=template&id=150a9d02&lang=pug"
import script from "./providerPtGlobalUpdate.vue?vue&type=script&lang=js"
export * from "./providerPtGlobalUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports